import { _delete, _get, _post, getUrlQueryParameterFromObject } from 'frontcore/utils/communications/apiClient'
import { OverviewWidget } from "frontend/communications/dto/PersonOverviewWidgetsLayout"

const URL = 'person-overview-widgets-layout/'
const DELETE_PERSON_OVERVIEW_WIDGET_BY_NAME_URL = 'delete-person-overview-widget-by-name/'

export function getOverviewWidgetsLayout () {
  return _get(URL).then(widgetsList => {
    return widgetsList.map(widget => {
      return new OverviewWidget({
        module: widget.module,
        widgetName: widget.widget_name,
        addedByPerson: widget.added_by_person,
        coordinates: widget.coordinates,
        props: widget.props,
      })
    })
  })
}

export function addWidgetToOverview (widgetName, module, coordinates, props) {
  return _post(URL, { widget_name: widgetName, module, coordinates, props })
}

export function removeWidgetFromOverview (widgetName, props) {
  const queryParams = getUrlQueryParameterFromObject(props, false)
  return _delete(`${URL}?widget=${widgetName}${queryParams ? '&' + queryParams : ''}`)
}

export function removeWidgetFromOverviewByNameForAllUsers (widgetName) {
  const queryParams = getUrlQueryParameterFromObject({
    widget: widgetName,
  }, false)
  return _delete(`${DELETE_PERSON_OVERVIEW_WIDGET_BY_NAME_URL}?${queryParams}`)
}
